module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.d1e3e53.woff";